import {
    getListChatCompany,
    getListChatTalent,
    setIsLoadNewListChat, 
    getNumberMessagesTalent,
    getNumberMessages, getTalentMessages, getMessages,
    setIsPaging, setIsSameChatSelected, setLoadingGetListChat
} from "reducers/chatMessage";
import {getListNotification} from "reducers/talentHome";

export const handleStaffSocketMessage = (dataInput: any, dispatch: any, chatMessage: any, globalFilterString: any): any => {
    let data: any;
    try {
        data = typeof dataInput === 'string' ? JSON.parse(dataInput) : dataInput;
    } catch (e) {
        return;
    }
    if(!data || !data.message) {
        return;
    }
    const { chatSelected, page, pageSize, isFlagFilter } = chatMessage || {}

    dispatch(getNumberMessages(""));

    if (window.location.href.includes('company/message')) {
        dispatch(setIsPaging(false))
        dispatch(getListChatCompany({
            page: 1, 
            pageSize: (page || 1) * (pageSize || 10), 
            filter: globalFilterString, 
            isFlag: isFlagFilter, 
            isSilent: true
        }));

        if(chatSelected && chatSelected?.id) {
            if(data.message.chat_conversation_id == chatSelected.id) {
                dispatch(setIsSameChatSelected(true));
                dispatch(getMessages({ id: chatSelected?.id }));
            } else {
                dispatch(setIsSameChatSelected(false));
            }
        }
    }
};

export const handleTalentSocketMessage = (dataInput: any, dispatch: any, chatMessage: any, isMobile: any): any => {
    let data: any;
    try {
        data = typeof dataInput === 'string' ? JSON.parse(dataInput) : dataInput;
    } catch (e) {
        return;
    }
    if(!data || !data.message) {
        return;
    }
    const { chatSelected, page, pageSize, isOpenChatListModal } = chatMessage || {};

    switch(data.message.type) {
        case 'chat':
            dispatch(setIsLoadNewListChat(true))
            dispatch(getNumberMessagesTalent(""));

            if (window.location.href.includes('talent/message')) {
                dispatch(setLoadingGetListChat(true))
                dispatch(setIsPaging(false))
                dispatch(getListChatTalent({page: 1, pageSize: (page || 1) * (pageSize || 15)}));

                if (chatSelected && chatSelected?.id) {
                    if (data.message.chat_conversation_id == chatSelected.id) {
                        dispatch(setIsSameChatSelected(true));
                        if(!isOpenChatListModal || !isMobile) {
                            dispatch(getTalentMessages({ id: chatSelected?.id }));
                        }
                    } else {
                        dispatch(setIsSameChatSelected(false));
                    }
                }
            }
            break;
        case 'noti':
            dispatch(getListNotification(""));
            break;
        default:
            break;
    }
};